import React from 'react';
import { initialsFor, avatarColorFor } from './icons';

const STATUS_META = {
  completed: { label: 'Completed', className: 'ma-pill--completed' },
  in_progress: { label: 'In Progress', className: 'ma-pill--in-progress' },
  not_started: { label: 'Not Started', className: 'ma-pill--not-started' },
};

const InviteRow = ({ row, stepPrefix = '', selected, onToggleSelect, canRevoke, onRevoke }) => {
  const status = STATUS_META[row.status] || STATUS_META.not_started;
  const pct = Math.max(0, Math.min(100, Number(row.progress_pct) || 0));
  const currentStep = row.current_step && row.current_step !== '-'
    ? `${stepPrefix}${row.current_step}`
    : '-';

  return (
    <div className={`ma-row${selected ? ' ma-row--selected' : ''}`}>
      <div className="ma-row__check">
        <input
          type="checkbox"
          checked={selected}
          onChange={onToggleSelect}
          aria-label={`Select ${row.name}`}
        />
      </div>

      <div className="ma-row__user">
        <span className="ma-avatar" style={{ background: avatarColorFor(row.email || row.name) }}>
          {initialsFor(row.name)}
        </span>
        <span className="ma-row__user-text">
          <span className="ma-row__name">{row.name}</span>
          <span className="ma-row__email">{row.email}</span>
        </span>
      </div>

      <div className="ma-row__progress">
        <span className="ma-progress-track">
          <span
            className={`ma-progress-fill${pct >= 100 ? ' ma-progress-fill--complete' : ''}`}
            style={{ width: `${pct}%` }}
          />
        </span>
        <span className="ma-progress-pct">{pct}%</span>
      </div>

      <div className="ma-row__step">{currentStep}</div>

      <div className="ma-row__status">
        <span className={`ma-pill ${status.className}`}>{status.label}</span>
      </div>

      <div className="ma-row__kebab">
        {canRevoke && (
          <button type="button" className="ma-row__revoke" onClick={onRevoke}>Revoke</button>
        )}
      </div>
    </div>
  );
};

export default InviteRow;
